import React, { useContext } from "react";
import "./PreApprovedListModal.css";
import { AppContext } from "../../../../AppContext";
import closeSvg from "../../../../assets/closeSvg";

const PreApprovedListModal = () => {
  const {
    preApprovedListModalVisible,
    setPreApprovedListModalVisible,
    setGeneratePreApprovalModal,
    matrixData,
    setInputPreApprovalNames,
  } = useContext(AppContext);

  const dataAvailable = () => {
    if (matrixData[0].Request === "No Request") {
      return false;
    } else {
      return true;
    }
  };

  let clientDataSorted = [];
  let preApprovedClients = [];
  let pendingClients = [];

  if (dataAvailable()) {
    const clientData = JSON.parse(matrixData[0]["Clients"]);
    clientDataSorted = clientData.sort((a, b) => {
      if (a["Name"][0] > b["Name"][0]) {
        return 1;
      } else {
        return -1;
      }
    });

    //Create arrays of Pending, Pre Approved, and Past Clients
    preApprovedClients = clientDataSorted.filter((e) => {
      return (
        e.MtgPlanner_CRM__Stage__c === "Pre-Approved" && e.Max_Pre_Approval__c
      );
    });

    pendingClients = clientDataSorted.filter((e) => {
      return (
        e.MtgPlanner_CRM__Stage__c === "New Lead" ||
        e.MtgPlanner_CRM__Stage__c === "Attempting Contact" ||
        e.MtgPlanner_CRM__Stage__c === "Appointment Scheduled" ||
        e.MtgPlanner_CRM__Stage__c === "Application Sent" ||
        e.MtgPlanner_CRM__Stage__c === "Docs Requested" ||
        e.MtgPlanner_CRM__Stage__c === "Docs Received"
      );
    });
  }

  let preApprovedList = [];
  let listOfClients;

  if (dataAvailable()) {
    if (preApprovedClients[0] == undefined) {
      listOfClients = (
        <div className="ClientRow grey">
          <div className="subtext">
            No current clients out shopping. Please let your loan officer know
            if you have any!
          </div>
        </div>
      );
    } else {
      function formatCurrency(number) {
        const formattedNumber = number.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return `$${formattedNumber}`;
      }
      preApprovedList = preApprovedClients.map((e, index) => {
        let preApprovalDateFormatted = "TBD";
        if (e.Pre_Approval_Date__c) {
          const rawPreApprovalDate = new Date(
            e.Pre_Approval_Date__c.toString()
          );
          preApprovalDateFormatted =
            rawPreApprovalDate.getMonth() +
            1 +
            "/" +
            rawPreApprovalDate.getDate() +
            "/" +
            rawPreApprovalDate.getFullYear().toString().substring(2, 4);
        }

        const clientName = e.Name;
        const loanOfficerName = e.Loan_Officer_Name__c;
        const loanOfficerEmail = e.Loan_Officer_Email__c;
        const loanOfficerPhone = e.Loan_Officer_Phone__c;
        const agentPartner = e.Agent_Contact_Name__c;
        const agentEmail = e.Agent_Contact_Email__c;
        const preApprovalAmt = formatCurrency(e.Max_Pre_Approval__c);
        const preApprovalDate = preApprovalDateFormatted;
        const floifyId = e.Floify_ID__c;
        const downpaymentPercentage = e.Downpayment__c;
        const downpaymentDollar = e.Preapproval_Downpayment__c;
        const loanProgram = e.Loan_Program__c;
        const googleTemplateID = e.LO_Pre_Approval_Template_ID__c;
        const googleFolderId = e.LO_Pre_Approval_Folder_ID__c;
        const preApprovalNames = e.Name_s_on_Letter__c;

        return {
          clientName,
          loanOfficerName,
          loanOfficerEmail,
          loanOfficerPhone,
          preApprovalAmt,
          preApprovalDate,
          agentPartner,
          agentEmail,
          downpaymentPercentage,
          downpaymentDollar,
          loanProgram,
          googleTemplateID,
          googleFolderId,
          preApprovalNames,
        };
      });
      listOfClients = preApprovedList.map((e, index) => {
        return (
          <div
            className="ClientRow"
            key={index}
            onClick={() => {
              setInputPreApprovalNames(e.preApprovalNames);
              setGeneratePreApprovalModal({
                status: "active",
                clientName: e.clientName,
                preApprovalAmount: e.preApprovalAmt,
                loanOfficerName: e.loanOfficerName,
                loanOfficerEmail: e.loanOfficerEmail,
                agentPartner: e.agentPartner,
                agentEmail: e.agentEmail,
                downpaymentPercentage: e.downpaymentPercentage,
                downpaymentDollar: e.downpaymentDollar,
                loanProgram: e.loanProgram,
                googleTemplateID: e.googleTemplateID,
                googleFolderId: e.googleFolderId,
                preApprovalNames: e.preApprovalNames,
              });
              setPreApprovedListModalVisible("hidden");
            }}
          >
            <div className="name">{e.clientName}</div>
            <div className="preApprovedAmt">{e.preApprovalAmt}</div>
          </div>
        );
      });
    }
  }

  return (
    <div className={`ModalPage ${preApprovedListModalVisible} one`}>
      <div className="Modal-background"></div>
      <div className="Modal-container">
        <form className="Modal">
          <div className="spaceBetween">
            <b>Generate Pre Approval</b>
            <div
              className="Modal-close"
              onClick={() => {
                setPreApprovedListModalVisible("hidden");
              }}
            >
              {closeSvg}
            </div>
          </div>
          Select a client below to generate a pre approval letter...
          {listOfClients}
        </form>
      </div>
    </div>
  );
};

export default PreApprovedListModal;
